/**
 * What is still owed on a one-off job.
 *
 * The server's figure (`remaining` on the job's financial summary) is the
 * authority: the open invoices' balances, tax included, plus any part of the
 * job total not invoiced yet. The job total itself is pre-tax, so reading it
 * quoted $667 on a job whose invoice was $763.76.
 *
 * Money still clearing (an accepted bank debit) counts as paid: the card
 * shows it as collected, with the clearing part noted. A summary that sends
 * `collected` has already netted it out of `remaining`; one that does not is
 * from a server that had not (a rolling deploy, or a response cached before
 * it), so it is netted out here. Without that the money read as collected
 * and owed at once. With no `remaining` at all (still loading) it falls back
 * to the job total less what is paid or clearing.
 *
 * The Billing card and the Record payment / payment-link dialogs all quote
 * this figure, so it lives in one place.
 */
export function remainingOnOneOffJob(
  grandTotal: number | string | null | undefined,
  summary:
    | { paid?: number; clearing?: number; collected?: number; remaining?: number }
    | null
    | undefined,
) {
  const clearing = Number(summary?.clearing || 0);
  if (typeof summary?.remaining === 'number') {
    const unnetted = typeof summary.collected === 'number' ? 0 : clearing;
    return Math.max(0, Math.round((summary.remaining - unnetted) * 100) / 100);
  }
  const collected = Number(summary?.paid || 0) + clearing;
  return Math.max(0, Math.round((Number(grandTotal || 0) - collected) * 100) / 100);
}
